import { reducer } from 'redux-form'

export default reducer.plugin({
  MissionAnswerForm: (state, { type, meta: { form } = {}, payload }) => {
    if (form === 'MissionAnswerForm') {
      switch (type) {
        case '@@redux-form/REGISTER_FIELD':
          if (!(state && state.values && (payload.name in state.values))) {
            return state
          }
          const values = { ...state.values }
          delete values[payload.name]
          return {
            ...state,
            values,
          }
        default:
          return state
      }
    }
    return state
  },
})



// WEBPACK FOOTER //
// ./src/reducers/form.jsx